import http from '../../HttpConfig'
import {APIS_ENDPOINTS} from '../../SERVICE-CONSTANTS'

const dashboard_endpoints = APIS_ENDPOINTS.dashboard

export const request_getpaneldashboard = async () => {
  return http.get(dashboard_endpoints.getpaneldashboard)
}
